// Core
import React from 'react';
import { shallowEqual } from 'react-redux';
// Components
import { LineChart } from '../common/LineChart';
// Hooks:
import { useDatesChartData } from '../../hooks/useDatesChartData';
// Other
import { useTypedSelector } from '../../redux';

export const GuidesPerSession: React.FC = () => {
  const {
    data: { guidesPerSession },
    mode,
    startDate,
    endDate,
  } = useTypedSelector(({ total }) => total, shallowEqual);
  const {
    labelsNames, chartData,
  } = useDatesChartData(mode, guidesPerSession, startDate, endDate);

  return (
    <>
      {chartData.length > 0 && (
      <LineChart
        theme="green"
        title="Website Guides per Session"
        subtitle="Amount open guides per session. One session is one unique user."
        label="Guides"
        labelsNames={labelsNames}
        data={chartData}
      />
      )}
    </>
  );
};
